import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { APP_ROOT_URL_CLNT } from "astro:env/client";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const isExternalUrl = (url: string) => {
  if (!url) return false;

  // Handle URLs that start with our app root as internal
  if (url.startsWith(APP_ROOT_URL_CLNT) || url.startsWith("/")) {
    return false;
  }

  // All other URLs are considered external
  return true;
};

// this function removes the last sentence from a text string
export function removeLastSentence(text: string): string {
  return text.split(".").slice(0, -2) + ".";
}
// returns a string preview of a text string with the the first specified number of characters minus 3 plus 3 dots
export function getStringPreview(text: string, length: number = 200): string {
  return text.slice(0, length - 3) + "...";
}

// replaces the word "and" with an ampersand in a text string
export function formatHeroHeadingText(text: string): string {
  return text.toLocaleLowerCase().replace(" and ", " & ").toUpperCase();
}

// checks if the browser supports webp images
export function supportsWebP(request: Request): boolean {
  const accept = request.headers.get("Accept") ?? "";
  return accept.includes("image/webp");
}

interface CheckForFocusElementReturnObject {
  found: boolean;
  id?: string;
}
export function checkAndGetUrlFocusElement(
  url: string,
  ids: string[],
): CheckForFocusElementReturnObject {
  const urlParts = url.split("#");
  const urlHash = urlParts[1];

  const found = ids.includes(urlHash);
  if (found && urlHash) {
    return { found, id: urlHash };
  }

  return { found };
}
